// Full lockup: mark + "BINARY ONE SOLUTIONS" wordmark + tagline.
// Used on Login, Sales Hub hero, and the cover of generated reports.

import LogoMark from './LogoMark';

export default function Logo({ tagline = true, dark = false, className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark className="h-12 w-12 shrink-0" />
      <div className={dark ? 'text-white' : 'text-ink-900'}>
        <div className="leading-none">
          <span className={`font-extrabold tracking-tight text-xl ${dark ? 'text-brand-400' : 'text-brand-600'}`}>BINARY ONE</span>
          <span className={`font-extrabold tracking-tight text-xl ml-1 ${dark ? 'text-white' : 'text-ink-900'}`}>SOLUTIONS</span>
        </div>
        {tagline && (
          <div className={`text-xs italic mt-1 ${dark ? 'text-slate-300' : 'text-slate-500'}`}>
            Digital Transformation Consulting
          </div>
        )}
      </div>
    </div>
  );
}
